import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {from, Observable} from 'rxjs';
import {AuthService} from "../auth.service";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {StatusEnum} from "@enums/statusEnum";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ActivationGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getStatus()===StatusEnum.NOT_ACTIVATED){
      return this.router.parseUrl(appRoutingEnum.ACTIVATION);
    }
    return (this.auth.getStatusFromStorage().pipe(map((statusFromStorage): boolean | UrlTree => {
      return statusFromStorage !== StatusEnum.NOT_ACTIVATED ? true : this.router.parseUrl(appRoutingEnum.ACTIVATION);
    })))
  }

}
